import { render, staticRenderFns } from "./LastStep_default.vue?vue&type=template&id=424e8a2e&scoped=true&"
import script from "./LastStep_default.vue?vue&type=script&lang=js&"
export * from "./LastStep_default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424e8a2e",
  null
  
)

export default component.exports